export default function floorFigure(figure: string, decimals: number) {
  // if (!decimals) decimals = 2
  const d: number = Math.pow(10, decimals)
  return (parseInt((+figure * d).toString()) / d).toFixed(decimals)
}
